export const passwordFrom7to20 = (password) => {
    return password.length >= 7 && password.length <= 20
}